import React from 'react';
import Layout from '../../components/layout';
import BrainDev from '../../components/one-oh-one/BrainDev';

const headerText = 'SUBSTANCE USE 101';

const OneOhOne = () => {
  return (
    <Layout
      headerText={headerText}
      heroFont="has-text-white"
      heroBg="dark-hero"
    >
      <BrainDev path="/one-oh-one/development" />
    </Layout>
  );
};

export default OneOhOne;
